import { useCallback, useLayoutEffect, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import Request from '@/utils/Request';
import Header from '@/components/h5/index/Header';
import Brand from '@/components/h5/index/Bands';
import ProTypes from '@/components/h5/index/ProTypes';
import Hots from '@/components/h5/index/Hots';
import Nav from '@/components/h5/index/Nav';
import Panel from '@/components/h5/index/Panel';
import Footer from '@/components/h5/index/Footer';
import test from '@/assets/images/test.gif';
import scan from '@/assets/images/h5image/scan.jpg';
import styles from './index.module.scss';
// const isWeChat = () => {
//   const ua = window.navigator.userAgent.toLowerCase();
//   const result = ua.match(/MicroMessenger/i) == 'micromessenger'; // 判定为true则是微信浏览器，false则不是
//   return result;
// };
export default () => {
  const [dataSource, setDataSource] = useState<Record<string, any>>({});
  const [videoH, setVideoH] = useState<number>(729);
  const videCurrentRef = useRef<boolean>(true);
  const bannerRef = useRef<any>();
  const videoRef = useRef<any>();
  const navigate = useNavigate();

  const search = useCallback(
    (keyword: string) => {
      console.log('searchKey===', keyword, location.pathname);
      if (location.pathname !== '/searchPage' && keyword) {
        navigate(`/searchPage?keyword=${keyword}`);
        return;
      }
    },
    [location]
  );
  const htmlDecode = useCallback((str: string) => {
    let temp: any = document.createElement('div');
    temp.innerHTML = str;

    const output = temp.innerText || temp.textContent;
    temp = null;
    return output;
  }, []);
  const loadData = useCallback(async () => {
    const res = await Request.post('/home', {});
    if (res.errno === 0) {
      let dataStr = JSON.stringify(res.data);
      dataStr = htmlDecode(dataStr);
      const dataJson = JSON.parse(dataStr);
      setDataSource(dataJson);
    }
  }, [htmlDecode]);
  const gotoDetail = useCallback((item: any) => {
    console.log('gotoDetail====', item);
    if (item.redirectUrlH5 || item.redirectUrl) {
      window.open(item?.redirectUrlH5 || item?.redirectUrl);
    }
  }, []);
  useLayoutEffect(() => {
    setTimeout(() => {
      videoRef?.current?.load();
    }, 100);
    videoRef?.current?.load();
    setTimeout(() => {
      videoRef?.current?.play();
    }, 300);
    if (videCurrentRef.current) {
      videoRef?.current?.play();
    }
  }, []);
  const changeSwiper = useCallback(() => {
    videoRef?.current?.load();
    setTimeout(() => {
      console.log('videCurrentRef.current===', videCurrentRef.current);
      if (videCurrentRef.current) {
        videoRef?.current?.play();
      } else {
        videoRef?.current?.pause();
      }
    }, 100);
  }, []);
  useLayoutEffect(() => {
    setTimeout(() => {
      const width = bannerRef.current.offsetWidth;
      const h = (width * 880) / 1480;
      setVideoH(h);
      videoRef?.current?.play();
    }, 200);
    // const video = document.querySelector('#video');
    // video?.addEventListener('dbclick', function (e) {
    //   console.log('addEventListener');
    // });
    // setTimeout(() => {
    //   const video = document.querySelector('#video');
    //   if (!video) {
    //     return;
    //   }
    //   // video.addEventListener('loadeddata', function () {
    //   const canvas = document.createElement('canvas');
    //   const canvasHeight = video.clientHeight;
    //   const canvasWidth = video.clientWidth;
    //   canvas.getContext('2d')?.drawImage(video, 0, 0, canvasWidth, canvasHeight);
    //   const dataURL = canvas.toDataURL('image/jpeg');
    //   alert(dataURL);
    //   video.setAttribute('poster', dataURL); // 设置video的封面
    //   // });
    // }, 1500);
  }, [videoRef.current]);
  useEffect(() => {
    loadData();
  }, [loadData]);
  return (
    <div className={styles['index-container']}>
      <Header />
      <Nav onSearch={(val: string) => search(val)} />
      <div className={styles['content']}>
        <div className={styles['banner']} ref={bannerRef}>
          {dataSource && (
            <Swiper
              autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
              modules={[Navigation, Scrollbar, Pagination, Autoplay]}
              className="container"
              spaceBetween={0}
              slidesPerView={1}
              navigation
              // onSlideChange={changeSwiper}
              pagination={{ clickable: true }}
            >
              {(dataSource.slideshow || []).map((item: any, index: number) => {
                const type = item.url.substring(item.url.lastIndexOf('.') + 1, item.url.length);
                return (
                  <SwiperSlide className="card" key={item.url}>
                    {({ isActive }: { isActive: boolean }) => {
                      console.log('isActive====', isActive);
                      if (isActive && index === 0 && type === 'mp4') {
                        videCurrentRef.current = true;
                      } else if (index === 0 && type === 'mp4' && !isActive) {
                        videCurrentRef.current = false;
                      }
                      return type === 'mp4' && index === 0 ? (
                        <div>
                          <video
                            id="video"
                            crossOrigin="anonymous"
                            ref={videoRef}
                            className={styles['banner-video']}
                            style={{ height: `${videoH}px`, objectFit: 'fill' }}
                            src={item.url}
                            loop={true}
                            preload="auto"
                            // eslint-disable-next-line react/no-unknown-property
                            webkit-playsinline={true}
                            // eslint-disable-next-line react/no-unknown-property
                            playsInline={true}
                            controls={true}
                            muted={true}
                            poster={scan}
                          ></video>
                          {/* <img src={test} style={{ width: '100vw' }} /> */}
                        </div>
                      ) : (
                        <img src={item.url} onClick={() => gotoDetail(item)} style={{ width: '100vw' }} />
                      );
                    }}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
        </div>
        <Brand brands={dataSource.brand} />
        <ProTypes types={dataSource.goodsCategory} />
        <Hots list={dataSource.goods} />
        <Panel links={dataSource?.navigation} />
        <Footer />
      </div>
    </div>
  );
};
